import { render, staticRenderFns } from "./TwitterCard.vue?vue&type=template&id=404d5de4&scoped=true&"
import script from "./TwitterCard.vue?vue&type=script&lang=js&"
export * from "./TwitterCard.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCard.vue?vue&type=style&index=0&id=404d5de4&lang=scss&scoped=true&"
import style1 from "./TwitterCard.vue?vue&type=style&index=1&id=404d5de4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d5de4",
  null
  
)

export default component.exports